/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestTrackingResponse
 */
export interface RequestTrackingResponse {
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    endpoint?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    apiVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    macAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    clientIp?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    httpMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    requestUri?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    userAgent?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    contentType?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingResponse
     */
    requestBodySize?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingResponse
     */
    responseStatus?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestTrackingResponse
     */
    executionTimeMs?: number;
    /**
     * 
     * @type {Date}
     * @memberof RequestTrackingResponse
     */
    requestTimestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RequestTrackingResponse
     */
    responseTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    firmwareVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    hardwareVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    manufacturer?: string;
    /**
     * Device status after update check (POSTPONED, PENDING, UP_TO_DATE)
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    deviceStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    additionalMetadata?: string;
    /**
     * Full response body sent to the device (truncated to 2000 chars)
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    responseBody?: string;
    /**
     * Whether an upgrade was offered to the device
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    upgradeAvailable?: string;
    /**
     * Target firmware version proposed in the response
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    targetFirmwareVersion?: string;
    /**
     * Size of the response body in bytes
     * @type {number}
     * @memberof RequestTrackingResponse
     */
    responseBodySize?: number;
    /**
     * Status description from the response sent to the device
     * @type {string}
     * @memberof RequestTrackingResponse
     */
    responseStatusDesc?: string;
}

export function RequestTrackingResponseFromJSON(json: any): RequestTrackingResponse {
    return RequestTrackingResponseFromJSONTyped(json, false);
}

export function RequestTrackingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestTrackingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'endpoint': !exists(json, 'endpoint') ? undefined : json['endpoint'],
        'apiVersion': !exists(json, 'apiVersion') ? undefined : json['apiVersion'],
        'macAddress': !exists(json, 'macAddress') ? undefined : json['macAddress'],
        'deviceId': !exists(json, 'deviceId') ? undefined : json['deviceId'],
        'clientIp': !exists(json, 'clientIp') ? undefined : json['clientIp'],
        'httpMethod': !exists(json, 'httpMethod') ? undefined : json['httpMethod'],
        'requestUri': !exists(json, 'requestUri') ? undefined : json['requestUri'],
        'userAgent': !exists(json, 'userAgent') ? undefined : json['userAgent'],
        'contentType': !exists(json, 'contentType') ? undefined : json['contentType'],
        'requestBodySize': !exists(json, 'requestBodySize') ? undefined : json['requestBodySize'],
        'responseStatus': !exists(json, 'responseStatus') ? undefined : json['responseStatus'],
        'executionTimeMs': !exists(json, 'executionTimeMs') ? undefined : json['executionTimeMs'],
        'requestTimestamp': !exists(json, 'requestTimestamp') ? undefined : (new Date(json['requestTimestamp'])),
        'responseTimestamp': !exists(json, 'responseTimestamp') ? undefined : (new Date(json['responseTimestamp'])),
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'deviceType': !exists(json, 'deviceType') ? undefined : json['deviceType'],
        'firmwareVersion': !exists(json, 'firmwareVersion') ? undefined : json['firmwareVersion'],
        'hardwareVersion': !exists(json, 'hardwareVersion') ? undefined : json['hardwareVersion'],
        'model': !exists(json, 'model') ? undefined : json['model'],
        'manufacturer': !exists(json, 'manufacturer') ? undefined : json['manufacturer'],
        'deviceStatus': !exists(json, 'deviceStatus') ? undefined : json['deviceStatus'],
        'additionalMetadata': !exists(json, 'additionalMetadata') ? undefined : json['additionalMetadata'],
        'responseBody': !exists(json, 'responseBody') ? undefined : json['responseBody'],
        'upgradeAvailable': !exists(json, 'upgradeAvailable') ? undefined : json['upgradeAvailable'],
        'targetFirmwareVersion': !exists(json, 'targetFirmwareVersion') ? undefined : json['targetFirmwareVersion'],
        'responseBodySize': !exists(json, 'responseBodySize') ? undefined : json['responseBodySize'],
        'responseStatusDesc': !exists(json, 'responseStatusDesc') ? undefined : json['responseStatusDesc'],
    };
}

export function RequestTrackingResponseToJSON(value?: RequestTrackingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'endpoint': value.endpoint,
        'apiVersion': value.apiVersion,
        'macAddress': value.macAddress,
        'deviceId': value.deviceId,
        'clientIp': value.clientIp,
        'httpMethod': value.httpMethod,
        'requestUri': value.requestUri,
        'userAgent': value.userAgent,
        'contentType': value.contentType,
        'requestBodySize': value.requestBodySize,
        'responseStatus': value.responseStatus,
        'executionTimeMs': value.executionTimeMs,
        'requestTimestamp': value.requestTimestamp === undefined ? undefined : (value.requestTimestamp.toISOString()),
        'responseTimestamp': value.responseTimestamp === undefined ? undefined : (value.responseTimestamp.toISOString()),
        'errorMessage': value.errorMessage,
        'deviceType': value.deviceType,
        'firmwareVersion': value.firmwareVersion,
        'hardwareVersion': value.hardwareVersion,
        'model': value.model,
        'manufacturer': value.manufacturer,
        'deviceStatus': value.deviceStatus,
        'additionalMetadata': value.additionalMetadata,
        'responseBody': value.responseBody,
        'upgradeAvailable': value.upgradeAvailable,
        'targetFirmwareVersion': value.targetFirmwareVersion,
        'responseBodySize': value.responseBodySize,
        'responseStatusDesc': value.responseStatusDesc,
    };
}

